// extracted by mini-css-extract-plugin
module.exports = {"grid":"wage-grid_grid__2gFWu"};